// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Subscription Management Styles */
.admin-subscription-container {
    padding: 24px;
    background-color: #f5f5f5;
    min-height: 100vh;
}

.subscription-stats-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    margin-bottom: 24px;
}

.subscription-filters {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 20px;
}

.subscription-table-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow: hidden;
}

.credit-form-modal {
    background: white;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
}

.status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.status-active {
    background-color: #e8f5e8;
    color: #2e7d32;
}

.status-expired {
    background-color: #fff3e0;
    color: #f57c00;
}

.status-cancelled {
    background-color: #ffebee;
    color: #d32f2f;
}

.status-suspended {
    background-color: #f5f5f5;
    color: #757575;
}

.subscription-actions {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
}

.credits-display {
    font-weight: 600;
    color: #1976d2;
}

.expiry-warning {
    color: #f57c00;
    font-weight: 600;
}

.user-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.user-name {
    font-weight: 600;
    color: #333;
}

.user-email {
    font-size: 0.875rem;
    color: #666;
}

.package-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.package-name {
    font-weight: 600;
    color: #333;
}

/* Assign Subscription Modal Styles */
.merchant-search-results {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin-top: 8px;
}

.merchant-result-item {
    padding: 12px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: background-color 0.2s;
}

.merchant-result-item:hover {
    background-color: #f5f5f5;
}

.merchant-result-item.selected {
    background-color: #e3f2fd;
    border-left: 4px solid #1976d2;
}

.selected-merchant-display {
    background-color: #e8f5e8;
    border: 1px solid #4caf50;
    border-radius: 4px;
    padding: 12px;
    margin-top: 8px;
}

.selected-package-display {
    background-color: #e3f2fd;
    border: 1px solid #1976d2;
    border-radius: 4px;
    padding: 12px;
    margin-top: 8px;
}

.custom-override-section {
    background-color: #fff3e0;
    border: 1px solid #ff9800;
    border-radius: 4px;
    padding: 16px;
    margin-top: 16px;
}

@media (max-width: 768px) {
    .admin-subscription-container {
        padding: 16px;
    }
    
    .subscription-filters {
        padding: 16px;
    }
    
    .subscription-actions {
        flex-direction: column;
        gap: 4px;
    }
    
    .user-info, .package-info {
        text-align: left;
    }
} `, "",{"version":3,"sources":["webpack://./src/components/AdminSubscriptionManagement/AdminSubscriptionManagement.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,qCAAqC;AACrC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* Admin Subscription Management Styles */\n.admin-subscription-container {\n    padding: 24px;\n    background-color: #f5f5f5;\n    min-height: 100vh;\n}\n\n.subscription-stats-card {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    margin-bottom: 24px;\n}\n\n.subscription-filters {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    margin-bottom: 20px;\n}\n\n.subscription-table-container {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    overflow: hidden;\n}\n\n.credit-form-modal {\n    background: white;\n    border-radius: 8px;\n    max-width: 600px;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.status-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.status-active {\n    background-color: #e8f5e8;\n    color: #2e7d32;\n}\n\n.status-expired {\n    background-color: #fff3e0;\n    color: #f57c00;\n}\n\n.status-cancelled {\n    background-color: #ffebee;\n    color: #d32f2f;\n}\n\n.status-suspended {\n    background-color: #f5f5f5;\n    color: #757575;\n}\n\n.subscription-actions {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n}\n\n.credits-display {\n    font-weight: 600;\n    color: #1976d2;\n}\n\n.expiry-warning {\n    color: #f57c00;\n    font-weight: 600;\n}\n\n.user-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.user-name {\n    font-weight: 600;\n    color: #333;\n}\n\n.user-email {\n    font-size: 0.875rem;\n    color: #666;\n}\n\n.package-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.package-name {\n    font-weight: 600;\n    color: #333;\n}\n\n/* Assign Subscription Modal Styles */\n.merchant-search-results {\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    margin-top: 8px;\n}\n\n.merchant-result-item {\n    padding: 12px;\n    border-bottom: 1px solid #f0f0f0;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.merchant-result-item:hover {\n    background-color: #f5f5f5;\n}\n\n.merchant-result-item.selected {\n    background-color: #e3f2fd;\n    border-left: 4px solid #1976d2;\n}\n\n.selected-merchant-display {\n    background-color: #e8f5e8;\n    border: 1px solid #4caf50;\n    border-radius: 4px;\n    padding: 12px;\n    margin-top: 8px;\n}\n\n.selected-package-display {\n    background-color: #e3f2fd;\n    border: 1px solid #1976d2;\n    border-radius: 4px;\n    padding: 12px;\n    margin-top: 8px;\n}\n\n.custom-override-section {\n    background-color: #fff3e0;\n    border: 1px solid #ff9800;\n    border-radius: 4px;\n    padding: 16px;\n    margin-top: 16px;\n}\n\n@media (max-width: 768px) {\n    .admin-subscription-container {\n        padding: 16px;\n    }\n    \n    .subscription-filters {\n        padding: 16px;\n    }\n    \n    .subscription-actions {\n        flex-direction: column;\n        gap: 4px;\n    }\n    \n    .user-info, .package-info {\n        text-align: left;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
